<template>
    <div class="reset-password-page">

        <Panel>
            <div class="reset-form login-form" v-if="!isResetSuccessful">
                <PasswordChangeForm
                    :error-message="errorMessage"
                    :current-password-required="false"
                    :is-processing="isLoading"
                    title="Reset your password"
                    change-password-label="Reset Password"
                    @change-password="handleResetRequest"
                />
            </div>
            <div v-else>
                <Alert type="success" message="You have successfully reset your password." />

                <a href="/">Go to Login</a>
            </div>
        </Panel>

    </div>
</template>

<script>
import {useLoading} from "@/hooks/use-loading";
import {resetPasswordViaToken} from "@/api/user";
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref} from "vue";

import Panel from "@/components/Panel";
import PasswordChangeForm from "@/pages/common/PasswordChangeForm";
import Alert from "@/components/Alert";
import {userState} from "@/stores/user";

export default {
    name: "ConfirmResetPasswordPage",
    components: {
        Alert,
        PasswordChangeForm,
        Panel,
    },
    setup() {
        const {isLoading, startLoading, stopLoading} = useLoading(false);

        const isResetSuccessful = ref(false);

        const errorMessage = ref('');

        const route = useRoute();
        const router = useRouter();

        onMounted(() => {
            if (userState.isLoggedIn) {
                router.push("/");
            }
        });

        const handleResetRequest = async ({new_password}) => {
            errorMessage.value = '';
            startLoading();

            try {
                await resetPasswordViaToken({
                    token: route.query.token,
                    new_password
                });

                isResetSuccessful.value = true;
            } catch (e) {
                errorMessage.value = e?.response?.data?.message ?? e.message;
            } finally {
                stopLoading();
            }
        };

        return {
            isLoading,
            isResetSuccessful,
            errorMessage,
            handleResetRequest,
        };
    }
}
</script>